var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-modal',{attrs:{"name":_vm.modalName,"title":_vm.title,"ok-title":_vm.okTitle,"cancel-title":_vm.cancelTitle,"max-width38":"","click-to-close":_vm.clickToClose},on:{"ok":_vm.handleConfirm,"cancel":_vm.handleCancel}},[_c('template',{slot:"body"},[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }